import Table from "components/elements/Table";
import { ECellType, IRowProps, TableColumn } from "components/elements/Table/MuiTable";
import I18n from "components/materials/I18n";
import { useCallback, useMemo } from "react";
import { IProductSelected } from "../ProductSelectorTable";
import Button from "components/elements/Button";
import { TrashIcon } from "@heroicons/react/24/outline";
import { EDemembrementType } from "common/enums/ProductSubscribed/EDemembrementType";
import { ESubscriptionProductType } from "common/enums/ProductSubscribed/ESubscriptionProductType";
import { getViagerRatio } from "utils/baremeViager";

function getDemembrementRatio(product: IProductSelected): number {
	const { subscriptionProductType, demembrementDuration, demembrementType, viagerAge } = product.dto;
	if (subscriptionProductType === ESubscriptionProductType.pleine_propriete) return 1;
	if (demembrementType === EDemembrementType.viager) {
		if (viagerAge === undefined || viagerAge === null) return 1;
		return getViagerRatio(viagerAge, subscriptionProductType) ?? 1;
	}
	if (!demembrementDuration) return 1;
	const key = product.product.demembrementKeys?.find((k) => k.duration === demembrementDuration);
	if (!key) return 1;
	return subscriptionProductType === ESubscriptionProductType.usufruit ? key.usufruitRatio : key.nueProprieteRatio;
}

type IProps = {
	productsInSubscription: IProductSelected[];
	setProductsInSubscription: (products: IProductSelected[]) => void;
};

export default function ProductSelectedTable(props: IProps) {
	const productCartColumsHead: TableColumn[] = useMemo(
		() => [
			{
				headContent: I18n.asset.pages.subscriptions.select_products.table.columns.subscription_product_type,
				key: "subscriptionProductType",
			},
			{
				headContent: I18n.asset.pages.subscriptions.select_products.table.columns.scpi,
				key: "name",
			},
			{
				headContent: I18n.asset.pages.subscriptions.select_products.table.columns.paiement_method,
				key: "paymentMethod",
			},
			{
				headContent: I18n.asset.pages.subscriptions.select_products.table.columns.quantity,
				key: "quantity",
			},
			// {
			// 	headContent: "",
			// 	key: "quantityLetter",
			// },
			{
				headContent: I18n.asset.pages.subscriptions.select_products.table.columns.calculated_price,
				key: "calculatedPrice",
				formatType: ECellType.EURO,
			},
			// {
			// 	headContent: "",
			// 	key: "amountLetter",
			// },
			{
				headContent: "",
				key: "delete",
				widthPercentage: 10,
			},
		],
		[],
	);

	const onDeleteProduct = useCallback(
		(product: IProductSelected) => {
			const newProducts = props.productsInSubscription.filter((p) => p.product.id !== product.product.id);
			props.setProductsInSubscription(newProducts);
		},
		[props],
	);

	const enrichedProductInCart: IRowProps[] = useMemo(
		() =>
			props.productsInSubscription.map((product) => {
				return {
					rowKey: product.product.id,
					subscriptionProductType: I18n.asset.enums.ESubscriptionProductType[product.dto.subscriptionProductType],
					name: product.product.name,
					paymentMethod: I18n.asset.enums.EPaymentMethod[product.dto.paymentMethod],
					calculatedPrice: product.dto.quantity * product.product.price * getDemembrementRatio(product),
					// quantityLetter: "todo",
					// amountLetter: "todo",
					quantity: product.dto.quantity,
					delete: (
						<Button
							onClick={() => {
								onDeleteProduct(product);
							}}>
							{I18n.asset.common.delete}
							<TrashIcon />
						</Button>
					),
				};
			}),
		[props, onDeleteProduct],
	);
	return (
		<Table columnsHead={productCartColumsHead} rows={enrichedProductInCart} placeholderSearchbar="Chercher un produit" searchbarDisabled onNext={null} heightMode="content" />
	);
}
